// A Plan's day is the Trail's (every Trail is in Tasmania for now), not the
// browser's, so "today" here matches what the server accepts. Mirrors
// backend/services/plans/trailTime.js.
const TRAIL_TIME_ZONE = 'Australia/Hobart';

// Today's Trail-local date, 'YYYY-MM-DD'.
export const trailToday = () =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone: TRAIL_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());

// An instant (ISO string) as a Trail-local day and time, e.g. 'Mon, 26 Oct,
// 10:30'.
export const formatTrailDateTime = (iso) =>
  new Intl.DateTimeFormat('en-AU', {
    timeZone: TRAIL_TIME_ZONE,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(new Date(iso));
